import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  isLoading?: boolean;
  className?: string;
}

export function Button({ 
  children, 
  variant = 'primary', 
  isLoading = false,
  className = '',
  ...props 
}: ButtonProps) {
  const baseStyles = "px-6 py-3 rounded-xl font-everett text-[14px] transition-all duration-200 disabled:opacity-50";
  const variants = {
    primary: "bg-white text-black hover:bg-[#F2F2F2]",
    secondary: "bg-white/[0.08] text-white hover:bg-white/[0.12]"
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${className}`}
      disabled={isLoading}
      {...props}
    >
      {isLoading ? (
        <div className="flex items-center justify-center">
          <div className="w-5 h-5 border-2 border-t-transparent border-white rounded-full animate-spin" />
        </div>
      ) : (
        children
      )}
    </button>
  );
}
